<template>

    <div class="layout__container">

        <div class="layout__margin-25-0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
                <el-breadcrumb-item><span class="text__colour-teal">Lapsed Customers</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <h3 class="text__align-center text__colour-teal">Lapsed Customers</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <LapsedCustomersSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></LapsedCustomersSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <div class="el-table__scroll-wrapper">
                    <div class="el-table__scroll-div">
                    </div>
                </div>
                <el-table class="el-table__09vh layout__height-1240px layout__scrolling__right" :data="sales.slice(this.start-1, this.end)" style="width: 100%;" @sort-change="handleSortOrderChange"
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column prop="territory" label="Territory" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="120px">
                    </el-table-column>
                    <el-table-column prop="branch" label="Branch" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="70px">
                    </el-table-column>
                    <el-table-column prop="brand" label="Brand" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="clientName" label="Client Name" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="branchName" label="Branch Name" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="address" label="Address" class-name="layout__width-20 el-table-column__no-pointer" sortable="custom" width="250px">
                    </el-table-column>
                    <el-table-column prop="clientTelephone" label="Client Tel" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="100px">
                    </el-table-column>
                    <el-table-column prop="clientEmail" label="Client Email" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="120px">
                    </el-table-column>
                    <el-table-column prop="status" label="Status" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="70px">
                    </el-table-column>
                    <el-table-column prop="lastOrderDate" label="Last Order Date" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getFormattedDate" width="100px">
                    </el-table-column>
                    <el-table-column prop="totalSixMonthSpend" label="Total 6 Month Spend" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount" width="100px">
                    </el-table-column>
                </el-table>
            </div>
            <div class="">
                <div class="layout__padding-clear layout__padding-8-0 layout__border__all-1px">
                    <div class="text__align-center layout__padding-8-0">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[20, 40, 60, 80, 100, 200]"
                            :page-size="200"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="this.sales.length">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import moment from 'moment';
    import LapsedCustomersSearch from '@/components/insights/LapsedCustomersSearch';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [dataFormatter, sortJsonArrayHelper],
        components: {
            LapsedCustomersSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                sales: [],
                totals: [],
                start: 1,
                end: 200,
                pagination: 200,
                loading: false,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    salesSource: "ANY PRODUCT",
                    salesSourceId: null,
                    salesStatus: 'ORDERED',
                    salesMonthYear: ('0' + (new Date().getMonth()+1)).slice(-2) + '/' + new Date().getFullYear(),
                    salesFreeText: ''
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        mounted() {
            var bw = document.getElementsByClassName("el-table__body-wrapper");
            bw[0].addEventListener('scroll', this.handleScroll1);
            var sw = document.getElementsByClassName("el-table__scroll-wrapper");
            sw[0].addEventListener('scroll', this.handleScroll2);
        },
        updated() {
            var h = document.getElementsByClassName("el-table__header");
            var sd = document.getElementsByClassName("el-table__scroll-div");
            sd[0].style.width = h[0].style.width;

            var bw = document.getElementsByClassName("el-table__body-wrapper");
            if (bw[0].scrollWidth > bw[0].clientWidth) {
                sd[0].style.display = "block";
            } else {
                sd[0].style.display = "none";
            }
        },
        methods: {
            handleScroll1(e) {
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[1].scrollLeft = bw[0].scrollLeft;
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                sw[0].scrollLeft = bw[0].scrollLeft;
            },
            handleScroll2(e) {
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[0].scrollLeft = sw[0].scrollLeft;
            },
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            getFormattedDate(row, column, cellValue) {
                let dateTimeArray = cellValue.toString().split("T");
                let dateArray = dateTimeArray[0].toString().split("-");
                return dateArray[0] + '/' + dateArray[1] + '/' + dateArray[2] + ' ' + dateTimeArray[1].slice(0,8);
            },
            handleSizeChange(val) {
                console.log(`${val} items per page`);

                this.pagination = val
                console.log(this.start)
                this.end = this.pagination;
                console.log(this.end)
            },
            handleCurrentChange(val) {
                console.log(`current page: ${val}`);

                this.start = (val - 1) * this.pagination + 1;
                console.log(this.start)
                this.end = val * this.pagination;
                console.log(this.end)
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            }
        }
    };
</script>